// Owner: account-settings (plan §9.3). Account › Profile.
import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '../../../features/account/ProfilePage';

export const Route = createFileRoute('/_settings/account/profile')({
  component: ProfilePage,
});
